import { gql } from "@apollo/client";

const { sharedUserFields } = require("../fragments/user");

const ADD_USER = gql`
  mutation CreateUser($args: CombinedCreateUserInput!, $emailToken: String) {
  createUser(args: $args, emailToken: $emailToken) {
    accessToken
    user {
      ... on InternalUser {
       ${sharedUserFields}
      }
      ... on DonorUser {
        ${sharedUserFields}
      }
      ... on FirmUser {
        ${sharedUserFields}
        crd
        firmCrd
        firmName
      }
      ... on EntityUser {
        ${sharedUserFields}
      }
    }
  }
}
`;

const UPDATE_UNKNOWN_USER = gql`
  mutation UpdateUnknownUser($userId: ID, $args: CombinedCreateUserInput!) {
  updateUnknownUser(userId: $userId, args: $args) {
    accessToken
    user {
      ... on InternalUser {
       ${sharedUserFields}
      }
      ... on DonorUser {
        ${sharedUserFields}
      }
      ... on FirmUser {
        ${sharedUserFields}
        crd
        firmCrd
        firmName
      }
      ... on EntityUser {
        ${sharedUserFields}
      }
    }
  }
}
`;

const UPDATE_USER = gql`
mutation UpdateUser($args: CombinedUpdateUserInput!, $userId: ID!) {
  updateUser(args: $args, userId: $userId) {
    ... on InternalUser {
      ${sharedUserFields}
    }
    ... on DonorUser {
      advisor {
        _id
        firstName
        lastName
      }
      ${sharedUserFields}
    }
    ... on FirmUser {
      ${sharedUserFields}
      crd
      firmCrd
      firmName
    }
    ... on EntityUser {
      ${sharedUserFields}
    }
  }
}
`;

const UPDATE_USER_TYPE = gql`
  mutation UpdateUserType($newUserRole: String!, $userId: ID!) {
    updateUserType(newUserRole: $newUserRole, userId: $userId) {
      user {
        ... on DonorUser {
          _id
        }
        ... on FirmUser {
          _id
        }
      }
    }
  }
`;

const ADD_ADMIN_USER = gql`
  mutation AddUser(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $address1: String!
    $city: String!
    $state: String!
    $zip: String!
    $country: String!
    $role: [String]
  ) {
    addUser(
      first_name: $firstName
      last_name: $lastName
      email: $email
      password: $password
      address_1: $address1
      city: $city
      state: $state
      zip: $zip
      country: $country
      role: $role
    ) {
      user {
        first_name
        last_name
      }
    }
  }
`;

const RESET_PASSWORD = gql`
  mutation ResetPassword($password: String!, $resetToken: String!) {
    resetPassword(password: $password, resetToken: $resetToken) {
      status
      accessToken
    }
  }
`;

const HARD_DELETE_USER = gql`
  mutation HardDeleteUser($userId: ID!) {
    hardDeleteUser(userId: $userId) {
      ... on InternalUser {
        _id
      }
      ... on DonorUser {
        _id
      }
      ... on FirmUser {
        _id
      }
      ... on EntityUser {
        _id
      }
      ... on UnknownUser {
        _id
      }
    }
  }
`;

export {
  ADD_USER,
  UPDATE_UNKNOWN_USER,
  UPDATE_USER,
  UPDATE_USER_TYPE,
  ADD_ADMIN_USER,
  RESET_PASSWORD,
  HARD_DELETE_USER
};
